/*
 * @Author: chj
 * @Date: 2024-10-17 09:42:25
 * @LastEditors: chj
 * @LastEditTime: 2024-10-17 09:44:34
 * @Description: 请填写简介
 */
import request from '@/utils/request'

// 首页导航查询
export function getMenuList(query) {
  return request({
    url: '/menu/listMenu',
    method: 'get',
    params: query
  })
}

export function getMenuById(query) {
  return request({
    url: '/menu/listMenuById',
    method: 'get',
    params: query
  })
}
